import { DataScope } from './../data-scope';
import { Page } from "../page";
import { OrderQueryScopeEnum } from '../../enums/order-query-scope.enum';

export class MergedDeliveryOrderRequest extends Page {
  orderQueryScope: OrderQueryScopeEnum;
  doNos: Array<string> | null;
  letterHeadOrgId: string | null;
  consigneeKey: Array<string> | null;
  doStatus: Array<string> | null;
  facility: string | null;
  dataScopes: DataScope[];
  etdDtStart: Date | null;
  etdDtEnd: Date | null;
  deliveryCategory: string | null;
  dropType: string | null;
  hasBooking: string | null;
  creater: Array<string> | null;
  sales: Array<string> | null;
  shipTo: Array<string> | null;
  createUserEmail: string | null;

  constructor() {
    super();
    this.orderQueryScope = OrderQueryScopeEnum.personal;
    this.doNos = [];
    this.letterHeadOrgId = null;
    this.consigneeKey = [];
    this.doStatus = null;
    this.facility = null;
    this.dataScopes = [];
    this.etdDtStart = null;
    this.etdDtEnd = null;
    this.deliveryCategory = null;
    this.dropType = null;
    this.hasBooking = '0';
    this.creater = [];
    this.sales = [];
    this.shipTo = [];
    this.createUserEmail = null;
  }
}
